import { useAppSelector } from 'app/hooks';
import { useDispatchOnMount } from './useDispatchOnMount';
import { getPatientTsvMeasureTypesAsync } from 'features/measures/measuresSlice';
import { selectTsvMeasureTypes } from 'features/measures/measuresSelector';

/**
 * Tipos de medida que el grupo del paciente sincroniza vía TSV a nivel dispositivo.
 *
 * Punto único de carga y consumo de esa lista: el dedup vive en la `condition` del thunk (estado
 * fresco en el momento del dispatch), así que da igual cuántos componentes monten este hook a la
 * vez — sale UNA petición por paciente, y un 'failed' se reintenta en el siguiente montaje.
 *
 * Devuelve la lista SOLO si pertenece a este paciente (el slice es un slot único con la última
 * carga): mejor sin iconos un instante que con los del grupo de otro paciente.
 */
export const usePatientTsvMeasureTypes = (patientId?: string): string[] => {
  const tsvMeasureTypes = useAppSelector(selectTsvMeasureTypes);

  useDispatchOnMount(
    (dispatch) => {
      if (patientId) {
        dispatch(getPatientTsvMeasureTypesAsync(patientId));
      }
    },
    [patientId],
  );

  return patientId && tsvMeasureTypes.patientId === patientId && tsvMeasureTypes.status === 'idle'
    ? tsvMeasureTypes.types
    : [];
};
